/**
 * Company: LifeAI, Copyright 2018, All Rights Reserved.
 * Author: Pavel Kostenko
 * Email: poul.kg@gmail.com
 * Date: 2019-03-14
 * Time: 19:50
 */
export enum EWeatherIcons {
  ClearSky = 'clear-sky',
  FewClouds = 'few-clouds',
  Mist = 'mist',
  Rain = 'rain',
  ScatteredClouds = 'scattered-clouds',
  ShowerRain = 'shower-rain',
  Snow = 'snow',
  Thunderstorm = 'thunderstorm'
}
